import { VideoEventCode } from "../enums/VideoEventCode";

export class VideoEventCodeGroups {
    static lowRiskCodes = [VideoEventCode.LowShock, VideoEventCode.LaneDeparture];

    static mediumRiskCodes = [
        VideoEventCode.MediumShock,
        VideoEventCode.Pedestrian,
        VideoEventCode.DriverDistraction,
        VideoEventCode.DriverFatigue,
        VideoEventCode.DriverYawn, VideoEventCode.Speed,
        VideoEventCode.BlindSpot
    ];

    static highRiskCodes = [
        VideoEventCode.HighShock,
        VideoEventCode.Braking,
        VideoEventCode.Turning,
        VideoEventCode.Acceleration,
        VideoEventCode.DriverOnPhone,
        VideoEventCode.Collision,
        VideoEventCode.VehicleTooClose,
        VideoEventCode.NoSeatBelt
    ];

    static urgentRiskCodes = [VideoEventCode.Button];

    static dmsEventCodes = [
        VideoEventCode.DriverOnPhone,
        VideoEventCode.DriverFatigue,
        VideoEventCode.DriverYawn,
        VideoEventCode.DriverSmoking,
        VideoEventCode.DriverDistraction,
        VideoEventCode.DriverAbsent,
        VideoEventCode.NoSeatBelt
    ];

    static adasEventCodes = [
        VideoEventCode.LaneDeparture,
        VideoEventCode.Collision,
        VideoEventCode.VehicleTooClose,
        VideoEventCode.BlindSpot,
        VideoEventCode.Pedestrian
    ];
}